import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import { constantRouterMap } from '@/router/routers';
import Layout from '@/layout/index';
import ParentView from '@/components/ParentView';
var permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    sidebarRouters: []
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
    SET_SIDEBAR_ROUTERS: function SET_SIDEBAR_ROUTERS(state, routers) {
      state.sidebarRouters = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, asyncRouter) {
      var commit = _ref.commit;
      commit('SET_ROUTERS', asyncRouter);
    },
    SetSidebarRouters: function SetSidebarRouters(_ref2, sidebarRouter) {
      var commit = _ref2.commit;
      commit('SET_SIDEBAR_ROUTERS', sidebarRouter);
    }
  }
};
import Config from "@/settings";
// Config.childrenApplications
var _filterAsyncRouter = function filterAsyncRouter(routers) {
  var isRewrite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // 遍历后台传来的路由字符串，转换为组件对象
  return routers.filter(function (router) {
    if (isRewrite && router.children) {
      router.children = filterChildren(router.children);
    }
    if (router.component) {
      var router_chilren = Config.childrenApplications.find(function (item) {
        return router.path.includes(item);
      });
      if (router.component === 'Layout' && !router_chilren) {
        // Layout组件特殊处理
        router.component = Layout;
      } else if (router.component === 'ParentView' && !router_chilren) {
        router.component = ParentView;
      } else {
        if (router_chilren) {
          delete router.component;
        } else {
          var component = router.component;
          router.component = loadView(component);
        }
      }
    }
    if (router.children && router.children.length) {
      router.children = _filterAsyncRouter(router.children, router, isRewrite);
    }
    return true;
  });
};
export { _filterAsyncRouter as filterAsyncRouter };
function filterChildren(childrenMap) {
  var children = [];
  childrenMap.forEach(function (el, index) {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView') {
        el.children.forEach(function (c) {
          c.path = el.path + '/' + c.path;
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c));
            return;
          }
          children.push(c);
        });
        return;
      }
    }
    children = children.concat(el);
  });
  return children;
}
export var loadView = function loadView(view) {
  return function (resolve) {
    return require(["@/views/".concat(view)], resolve);
  };
};
export var firstRedirectRouter = function firstRedirectRouter(routers) {
  var routerItem = null;
  routers.forEach(function (item) {
    if (routerItem) {
      return;
    }
    if (item.hidden) {
      return;
    }
    if (item.children && item.children.length) {
      routerItem = _filterRedirectRouter(item.children, routerItem);
    } else {
      routerItem = item;
    }
  });
  return routerItem;
};
var _filterRedirectRouter = function filterRedirectRouter(routers, routerItem) {
  routers.forEach(function (item) {
    if (routerItem) {
      return;
    }
    if (item.hidden) {
      return;
    }
    if (item.children && item.children.length) {
      routerItem = _filterRedirectRouter(item.children, routerItem);
    } else {
      routerItem = item;
    }
  });
  return routerItem;
};
export default permission;